/* eslint-disable camelcase */
import { MessageBox } from 'element-ui'
var CreatedOKLodop7766 = null; var CLodopIsLocal

// ====判断是否需要 Web打印服务CLodop:===
// ===(不支持插件的浏览器版本需要用它)===
function needCLodop () {
  try {
    var ua = navigator.userAgent
    if (ua.match(/Windows\sPhone/i)) return true
    if (ua.match(/iPhone|iPod|iPad/i)) return true
    if (ua.match(/Android/i)) return true
    if (ua.match(/Edge\D?\d+/i)) return true

    var verTrident = ua.match(/Trident\D?\d+/i)
    var verIE = ua.match(/MSIE\D?\d+/i)
    var verOPR = ua.match(/OPR\D?\d+/i)
    var verFF = ua.match(/Firefox\D?\d+/i)
    var x64 = ua.match(/x64/i)
    if ((!verTrident) && (!verIE) && (x64)) return true
    else if (verFF) {
      verFF = verFF[0].match(/\d+/)
      if ((verFF[0] >= 41) || (x64)) return true
    } else if (verOPR) {
      verOPR = verOPR[0].match(/\d+/)
      if (verOPR[0] >= 32) return true
    } else if ((!verTrident) && (!verIE)) {
      var verChrome = ua.match(/Chrome\D?\d+/i)
      if (verChrome) {
        verChrome = verChrome[0].match(/\d+/)
        if (verChrome[0] >= 41) return true
      }
    }
    return false
  } catch (err) {
    return true
  }
}

// ====页面引用CLodop云打印必须的JS文件,用双端口(8000和18000）避免其中某个被占用：====
if (needCLodop()) {
  // 判断当前页面是http还是https
  /* var curUrl = window.location.href */
  var src1 = 'http://localhost:8000/CLodopfuncs.js?priority=1'
  var src2 = 'http://localhost:18000/CLodopfuncs.js?priority=0'
  /* if (curUrl.includes('https')) {
    src1 = 'https://localhost:8443/CLodopfuncs.js?priority=1'
    src2 = 'https://localhost:8444/CLodopfuncs.js?priority=0'
  } */

  var head = document.head || document.getElementsByTagName('head')[0] || document.documentElement
  var oscript = document.createElement('script')
  oscript.src = src1
  head.insertBefore(oscript, head.firstChild)
  oscript = document.createElement('script')
  oscript.src = src2
  head.insertBefore(oscript, head.firstChild)
  CLodopIsLocal = !!((src1 + src2).match(/\/\/localho|\/\/127.0.0./i))
}

// ====获取LODOP对象的主过程：====
export function getLodop (oOBJECT, oEMBED) {
  var tip = ''
  var strHtmInstall = "<br><font >打印控件未安装!点击这里<a style='text-decoration: underline;' href='http://www.lodop.net/download.html' target='view_window'>执行安装</a>,安装后请刷新页面或重新进入。</font>"
  var strHtmUpdate = "<br><font >打印控件需要升级!点击这里<a style='text-decoration: underline;' href='http://www.lodop.net/download.html' target='view_window'>执行升级</a>,升级后请重新进入。</font>"
  var strHtm64_Install = "<br><font >打印控件未安装!点击这里<a style='text-decoration: underline;' href='http://www.lodop.net/download.html' target='view_window'>执行安装</a>,安装后请刷新页面或重新进入。</font>"
  var strHtm64_Update = "<br><font >打印控件需要升级!点击这里<a style='text-decoration: underline;' href='http://www.lodop.net/download.html' target='view_window'>执行升级</a>,升级后请重新进入。</font>"
  var strHtmFireFox = "<br><br><font >（注意：如曾安装过Lodop旧版附件npActiveXPLugin,请在【工具】->【附加组件】->【扩展】中先卸它）</font>"
  var strHtmChrome = "<br><br><font >(如果此前正常，仅因浏览器升级或重安装而出问题，需重新执行以上安装）</font>"
  // eslint-disable-next-line camelcase
  var strCLodopInstall_1 = "<br><font>Web打印服务CLodop未安装启动，点击这里<a style='text-decoration: underline;' href='http://www.lodop.net/download.html' target='view_window'>下载执行安装</a>"
  // eslint-disable-next-line camelcase
  var strCLodopInstall_2 = "<br>（若此前已安装过，可<a style='text-decoration: underline;' href='CLodop.protocol:setup' target='_self'>点这里直接再次启动</a>）"
  var strCLodopInstall_3 = '，成功后请刷新本页面。</font>'
  var strCLodopUpdate = '<br><font>Web打印服务CLodop需升级!点击这里<a style="text-decoration: underline;" href="http://www.lodop.net/download.html" target="view_window">执行升级</a>,升级后请刷新页面。</font>'
  var LODOP
  try {
    var ua = navigator.userAgent
    var isIE = !!(ua.match(/MSIE/i)) || !!(ua.match(/Trident/i))
    if (needCLodop()) {
      try {
        // eslint-disable-next-line no-undef
        LODOP = getCLodop()
      } catch (err) {}
      if (!LODOP && document.readyState !== 'complete') {
        alert('网页还没下载完毕，请稍等一下再操作.')
        return
      }
      if (!LODOP) {
        tip = strCLodopInstall_1 + (CLodopIsLocal ? strCLodopInstall_2 : '') + strCLodopInstall_3 + tip
        MessageBox.alert(tip, {
          dangerouslyUseHTMLString: true
        })
        return
      } else {
        // eslint-disable-next-line no-undef
        if (CLODOP.CVERSION < '3.0.9.2') {
          tip = strCLodopUpdate + tip
        }
        // eslint-disable-next-line curly
        if (oEMBED && oEMBED.parentNode)
          oEMBED.parentNode.removeChild(oEMBED)
        // eslint-disable-next-line curly
        if (oOBJECT && oOBJECT.parentNode)
          oOBJECT.parentNode.removeChild(oOBJECT)
      }
    } else {
      var is64IE = isIE && !!(ua.match(/x64/i))
      // =====如果页面有Lodop就直接使用，没有则新建:==========
      if (oOBJECT || oEMBED) {
        if (isIE) LODOP = oOBJECT
        else LODOP = oEMBED
      } else if (!CreatedOKLodop7766) {
        LODOP = document.createElement('object')
        LODOP.setAttribute('width', 0)
        LODOP.setAttribute('height', 0)
        LODOP.setAttribute('style', 'position:absolute;left:0px;top:-100px;width:0px;height:0px;')
        if (isIE) LODOP.setAttribute('classid', 'clsid:2105C259-1E0C-4534-8141-A753534CB4CA')
        else LODOP.setAttribute('type', 'application/x-print-lodop')
        document.documentElement.appendChild(LODOP)
        CreatedOKLodop7766 = LODOP
      } else LODOP = CreatedOKLodop7766
      // =====Lodop插件未安装时提示下载地址:==========
      if ((!LODOP) || (!LODOP.VERSION)) {
        // eslint-disable-next-line curly
        if (ua.indexOf('Chrome') >= 0)
          tip = strHtmChrome + tip
        // eslint-disable-next-line curly
        if (ua.indexOf('Firefox') >= 0)
          tip = strHtmFireFox + tip
        tip = (is64IE ? strHtm64_Install : strHtmInstall) + tip
        MessageBox.alert(tip, {
          dangerouslyUseHTMLString: true
        })
        return LODOP
      }
    }
    if (LODOP.VERSION < '6.2.2.6') {
      if (!needCLodop()) {
        tip = (is64IE ? strHtm64_Update : strHtmUpdate) + tip
      }
    }
    if (!LODOP) {
      MessageBox.alert(tip, {
        dangerouslyUseHTMLString: true
      })
    }
    // ===如下空白位置适合调用统一功能(如注册语句、语言选择等):==
    // =======================================================
    LODOP.SET_LICENSES("","EF56AFB27DEFC5370C1A68636F8F8C88AB3","","");
    return LODOP
  } catch (err) {
    alert('getLodop出错:' + err)
  }
}
